export default __webpack_public_path__ + "d8cab2bdd56ea3b4515c244ed6cab32e.png";